var loader = document.getElementById('preloader');
var body = document.getElementById('body');
var footer = document.getElementById('footer');
const tocList = document.querySelector('.gh-toc');
const copyRight = document.querySelector('.copy-right');

async function initTranslations() {
    window.i18next.init({
        lang: ['en', 'nl'],
        fallbackLng: 'en',
        resources: {
            en: {
                translation: window.en
            },
            nl: {
                translation: window.nl
            },

        }
    }, function (err, t) {
        populateTranslationText()
    });
    // ... rest of your code using en and nl objects
}

window.addEventListener('load', async function () {
    await initTranslations();
    loader.classList.add('hidden');
    body.classList.remove('hidden');
    footer.classList.replace('hidden', 'flex');
    const currentYear = window.env.CURRENT_YEAR;
    copyRight.textContent = `\u00A9 ${currentYear} bettercollected`;
    if (tocList) {
        if (tocList.children.length === 0) {
            this.document.querySelector('.toc').classList.add('hidden');
        }
    }
});

function populateTranslationText() {
    const language = window.localStorage.getItem("language") ?? 'en'
    itemHandler(language)
}


